import { isFetchBaseQueryError } from "helpers";

export class ReviewRefreshRequiredError extends Error {}

export const isReviewRefreshRequired = (error: unknown): boolean =>
  error instanceof ReviewRefreshRequiredError ||
  (isFetchBaseQueryError(error) && error.status === 409);
